import axios from "axios";
import { Robot } from "../../../../models";
import { StandardAxiosConfig, getBaseDataURL } from "../../../common";
import { DataAPI_Base } from "../base";

class GetAPI_Robots {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getBaseDataURL("robots")}/get`;
	}

	public async byIdWithRaw(id: string, start: Date, end: Date): Promise<Robot> {
		const params = new URLSearchParams({
			start: start.toISOString(),
			end: end.toISOString(),
			raw: "true",
		});
		const url = `${this.baseUrl}/${id}?${params}`;
		const response = await axios.get(url, StandardAxiosConfig());
		return Object.assign(new Robot(), response.data as Robot);
	}
}

export class RobotsAPI extends DataAPI_Base<Robot> {
	robots: GetAPI_Robots;
	constructor() {
		super("robots", Robot);
		this.robots = new GetAPI_Robots();
	}
}
